import { Typography, Box, TableContainer, Table, TableHead, TableBody, TableCell, Paper, TableRow, Tooltip } from '@mui/material'
import styled from 'styled-components';
import { RemoveRedEye } from '@mui/icons-material';
import { TableHeadCell } from '../../components/styledComponent/table/TableCell';
import { useNavigate } from 'react-router';
import { useEffect, useState } from 'react';
import { TablePagination } from '../../components/pagination/Pagination';

const BoxContainer = styled(Box)`
display:flex;
flex-direction:column;
gap=20px;
`;

const CompletedLogs = ({ completedVisits, loading, setLoading, fetchCompletedVisits, count }: { completedVisits: Array<any>, loading: any, setLoading: any, fetchCompletedVisits: any, count: any }) => {

  const navigate = useNavigate();
  const [skip, setSkip] = useState(0)
  const [take, setTake] = useState(10)

  useEffect(() => {
    setLoading('completed')
    fetchCompletedVisits(skip, take)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [take, skip])

  return (
    <BoxContainer>
      <Typography variant='h6' component={'p'}>Completed</Typography>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 460 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableHeadCell align="left" minwidth="100px">
                  Duration
                </TableHeadCell>
                <TableHeadCell align="left" minwidth="120px">
                  Customer
                </TableHeadCell>
                <TableHeadCell align="center" minwidth="40px">
                  Locker
                </TableHeadCell>
                <TableHeadCell align="center" minwidth="40px">
                  Action
                </TableHeadCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {((completedVisits && completedVisits?.length <= 0) || loading === 'completed') ?
                <TableRow>
                  <TableCell colSpan={4} align='center'>No Data Found</TableCell>
                </TableRow>
                : completedVisits?.map((row, index) => (
                  <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell style={{ fontSize: "12px", padding: '4px 6px' }}>{`${row.checkInTime} - ${row.checkOutTime}`}</TableCell>
                    <TableCell style={{ fontSize: "12px", padding: '4px 0' }}>{`${row.acNo} (${row.customerName})`}</TableCell>
                    <TableCell align='center' style={{ fontSize: "12px", padding: '4px 6px' }}>{row.lockerNo}</TableCell>
                    <TableCell align='center' style={{ fontSize: "12px", padding: '4px 6px' }}>
                      <Tooltip title="View customer details">
                        <RemoveRedEye sx={{ width: '30px', height: '30px', backgroundColor: '#3150A1', borderRadius: '100%', padding: '6px', color: 'white' }} onClick={() => navigate(`/customers/${row.customerId}?isMainTable=true`)} />
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>
        {(completedVisits?.length > 0) ? <TablePagination count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} /> : null}
      </Paper>
    </BoxContainer>
  )
}

export default CompletedLogs
